import React from 'react'

import Image from 'next/image'

import { SectionContainer } from 'Components/Blocks'
import AppearingWrapper from 'Components/Blocks/AppearingWrapper'
import { Button, Column, Row, Text } from 'Components/UI'

import { BackgroundImage } from 'Assets/Images/Sections/ClubhouseHeroSection'
import { StripedCircleSvg } from 'Assets/Svg'

import { LANDING_CONTENT_PX } from 'Constants/Landing'

import { useResponsiveLayout } from 'Hooks'

import { Container, Overlay, Title } from './styles'

type Props = {
  onAction?: () => void
}

function ClubhouseHeroSection({ onAction }: Props) {
  const { isMobile } = useResponsiveLayout()

  return (
    <SectionContainer>
      <Row px={LANDING_CONTENT_PX}>
        <Container mt={5} px={[6, 6, 14, 14, 21]} py={[14, 14, 14, 14, 21]}>
          <Image alt="" src={BackgroundImage} />

          <Overlay />

          <Column
            alignCenter={isMobile}
            alignStart={!isMobile}
            gap={6}
            width={[1, 1, 1 / 2]}
          >
            <AppearingWrapper centered={isMobile} kind="expand">
              <Title flexDirection={['column', 'column', 'row']}>
                {StripedCircleSvg()}

                <Text as="h1" bold center={isMobile} inverse screen18>
                  All the latest happening with Emajin
                </Text>
              </Title>
            </AppearingWrapper>

            <Text
              as="h3"
              bold
              center={isMobile}
              inverse
              mb={5}
              mt={3}
              screen40={isMobile}
              screen52={!isMobile}
            >
              The Clubhouse
            </Text>

            <Text
              center={isMobile}
              inverse
              mb={7}
              medium
              screen14={isMobile}
              screen20={!isMobile}
            >
              Everything you need to know about the Emajin Golf community,
              including news, upcoming events, competition results and golf
              education, to keep you at the top of your game!
            </Text>

            <Button large mb={6} onClick={onAction}>
              Join Us Today
            </Button>
          </Column>
        </Container>
      </Row>
    </SectionContainer>
  )
}

export default ClubhouseHeroSection
